import { css } from '@emotion/react';

import { fluid, mq } from '../../style-tokens';

export default (themeColor = 'black') => css`
  margin-bottom: ${fluid(4, 8)};
  margin-left: 0;
  margin-top: ${fluid(2, 3)};

  @media ${mq.tablet} {
    margin-left: ${fluid(-1.5, -3)};
  }

  > p {
    color: ${themeColor};
    font-size: ${fluid(2, 2.75)};
    font-weight: 700;
    letter-spacing: 0.02rem;
    line-height: 1.17;

    @media (min-width: 2300px) {
      font-size: ${fluid(3, 3.5)};
    }
  }
`;
